import React from "react";

const PerformanceReports = ({performance_reports ,delivery_stats}) => {
  return (
    <>
      
      <h5 className="fw-bold mb-3">تقارير الأداء</h5>
      <div className="row">
        <div className="col-md-6 mt-2">
          <div className="bg-smoke  rounded-3 p-4">
            <h4 className="font14 fw-bold desc text-start mb-3">الإيرادات هذا الشهر</h4>
            <h4 className="text-green  fw-bold"> {performance_reports?.monthly_deliveries}{delivery_stats?.currency_symbol}</h4>
          </div>
        </div>
  
   
      
           <div className="col-md-6 mt-2">
          <div className="bg-smoke  rounded-3 p-4">
            <h4 className="font14 fw-bold desc text-start mb-3">   التسليمات هذا الشهر </h4>
            <h4 className="  fw-bold"> {performance_reports?.monthly_deliveries}</h4>
          </div>
        </div>
        
        <div className="col-md-6 mt-2">
          <div className="bg-smoke  rounded-3 p-4">
            <h4 className="font14 fw-bold desc text-start mb-3"> الطلبات الملغاة </h4>
            <h4 className="text-danger  fw-bold"> {performance_reports?.cancelled_orders}</h4>
          </div>
        </div>
    
         
        <div className="col-md-6 mt-2">
          <div className="bg-smoke  rounded-3 p-4">
            <h4 className="font14 fw-bold desc text-start mb-3">  التسليم في الوقت </h4>
            <h4 className="text-green  fw-bold"> {performance_reports?.on_time_percentage}%</h4>
          </div>
        </div>
      </div>
 
      
   
 
    </>

  );
};

export default PerformanceReports;
